module.exports = __webpack_public_path__ + "static/media/logout.952528de.svg";